import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSignOut = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3 3.99967V1.33301H8.33333V3.99967",
			stroke: "#333333",
			strokeWidth: 1.33,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.33333 12V14.6667H3V12",
			stroke: "#333333",
			strokeWidth: 1.33,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.66699 11.3337V4.66699",
			stroke: "#333333",
			strokeWidth: 1.33,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.00032 7.99902H14.667",
			stroke: "#333333",
			strokeWidth: 1.33,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0003 10.666L14.667 7.99935L12.0003 5.33268",
			stroke: "#333333",
			strokeWidth: 1.33,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgSignOut;
